import { SimpleForm, useEditContext, useGetIdentity, useGetOne } from "react-admin"
import Form from "../inputFormComponents/Form"
import FormCardCompany from "../company/FormCardCompany"
import FormCardTextModel from "../textModel/FormCardTextModel"
import textModelTemplate from "../fixtures/textModelTemplate"

const FormInput = () => {

  const { data: identity, isLoading: identityLoading } = useGetIdentity()
  const { data: user, isLoading: userLoading} = useGetOne("users", {id: identity?.id})
  const { record: customer, isLoading: customerLoading} = useEditContext()
  if(identityLoading || userLoading || customerLoading || !identity) return null

  const textModel = customer?.textModel ? customer.textModel : (user.textModel ? user.textModel : textModelTemplate)
  const configTextModel = customer?.textModel ? "show" : "hide"

  const cards = [
    <FormCardCompany />, 
    <FormCardTextModel initConfigTextModel={configTextModel} textModel={textModel} />
  ]

  return (
    <SimpleForm 
      defaultValues={{userId: identity.id, configTextModel: configTextModel, textModel: textModel}} 
    >
      <Form 
        cards={cards} 
      />
    </SimpleForm>
  )
}

export default FormInput